import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { WebcamDialogComponent } from '../webcam-dialog/webcam-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { map, Observable, startWith } from 'rxjs';
import { PlanProtectionService } from '../../../app/service/plan-protection/plan-protection.service';

@Component({
  selector: 'app-seleccionar-sucursal-dialog',
  templateUrl: './seleccionar-sucursal-dialog.component.html',
  styleUrl: './seleccionar-sucursal-dialog.component.scss'
})
export class SeleccionarSucursalModalComponent {

  title = ''
  controlSucursal = new FormControl(JSON.parse(localStorage.getItem('sucursal')) ?? {});
  sucursales = [];
  filteredSucursales: Observable<any>;
  sucursalForm: FormGroup
  planDetalle
  step = 1
  kilometraje
  base64Tacometro = ''

  constructor(
    public dialogRef: MatDialogRef<SeleccionarSucursalModalComponent>,
    private dialog: MatDialog,
    private planProtectionService: PlanProtectionService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = 'Seleccion de Sucursal'
    this.planDetalle = data.planDetalle
    let array = JSON.parse(localStorage.getItem('sucursales') || '[]');
    this.sucursales = array
    this.sucursalForm = this.fb.group({
      controlSucursal: [JSON.parse(localStorage.getItem('sucursal')) ?? {}, [Validators.required]],
    })

    if(array.length === 1){
      this.step = 2
      localStorage.setItem('sucursal_name', array[0].nombreSucursal);
      localStorage.setItem('sucursal_id', array[0].sucursalId);
      localStorage.setItem('sucursal_empresa_id', array[0].empresaId);
      localStorage.setItem('first_access', "0");
      localStorage.setItem('sucursal_select', JSON.stringify(array[0]))
    }
  }

  ngOnInit() {
  this.filteredSucursales = this.controlSucursal.valueChanges.pipe(
    startWith(''),
    map(value => this._filterSucursales(value || ''))
  );
}

  getUsuario() {
    return localStorage.getItem('firstName');
  }

  private _filterSucursales(value) {
    const filterValue = this._normalizeValue(
      typeof value === 'string' ? value : value?.nombreSucursal || ''
    );

    return this.sucursales.filter(sucursal =>
      this._normalizeValue(sucursal.nombreSucursal).includes(filterValue)
    );
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  // Función para mostrar el nombre en el input
  displaySucursal(sucursal: any): string {
    return sucursal && sucursal.nombreSucursal ? sucursal.nombreSucursal : '';
  }

  guardar() {
    this.step ++
    this.title = 'Captura de Tacometro'

    // window.location.reload()
    // this.closeDialog()
}

  validarKilometraje(){
    let body = {
      planProDetail: {
        EmpresaId: this.planDetalle.empresaId,
        OrdenVentaPlanProtectionId: this.planDetalle.ordenVentaPlanProtectionId,
        SkuPlanProtection: this.planDetalle.skuPlanProtection
      },
      currentKm: parseInt(this.kilometraje) 
    }
    this.planProtectionService.validarKilometrajePlan(body).subscribe(
      data => {
        const sucursalSeleccionada = this.controlSucursal.value;
        if (sucursalSeleccionada) {
          localStorage.setItem('sucursal_name', sucursalSeleccionada.nombreSucursal);
          localStorage.setItem('sucursal_id', sucursalSeleccionada.sucursalId);
          localStorage.setItem('sucursal_empresa_id', sucursalSeleccionada.empresaId);
          localStorage.setItem('first_access', "0");
          localStorage.setItem('sucursal_select', JSON.stringify(sucursalSeleccionada))
          this.closeDialog(data.code !== 400)
        }
      }
    )
  }

  onImage(event: { image: string; opcion: number }): void {
    this.base64Tacometro = event.image
  }

  desactivarContinuar(event: { opcion: number }): void {
    this.base64Tacometro = undefined
  }

  getDisabled(){
      return this.base64Tacometro !== undefined && this.kilometraje !== '' && this.kilometraje !== undefined ? false : true
  }

  soloNumeros(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    const esNumero = /^[0-9]$/.test(event.key);

    if (!esNumero && !teclasPermitidas.includes(event.key)) {
      event.preventDefault();
    }
  }

  limpiarCaracteresNoNumericos(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Elimina cualquier carácter que no sea número
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  closeDialog(bool){
    this.dialogRef.close({event: 2, base64Tacometro: this.base64Tacometro, kilometraje: this.kilometraje, success: bool})
  }

  closeDialogCancel(){
    this.dialogRef.close({event: 4})
  }
}